export const NOT_STARTED = 'not-started';
export const DONE = 'done';
export const TOUR_EXIT_ACTION = {
  CLOSE: 'close',
  FINISH: 'finish'
};